import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import {
  backgroundImage,
  backgroundPosition,
  backgroundRepeat,
  backgroundSize,
  border,
  borderRadius,
  display,
  height,
  space,
  width,
} from 'styled-system';

import { focusOutlineCSSWithOffset } from 'common/theme/styles';
import { boxSizing, cursor } from 'common/theme/system-utilities';

const UnstyledAttachedPicture = styled.div<any>`
  ${display};
  ${height};
  ${width};
  ${backgroundImage};
  ${backgroundRepeat};
  ${backgroundPosition};
  ${backgroundSize};
  ${space};
  ${border};
  ${borderRadius};
  ${boxSizing};
  ${cursor};

  ${focusOutlineCSSWithOffset};
`;

const AttachedPicture = (props: ComponentProps<typeof UnstyledAttachedPicture>) => (
  <UnstyledAttachedPicture
    role="button"
    tabIndex={0}
    display="inline-block"
    backgroundRepeat="no-repeat"
    backgroundSize="contain"
    backgroundPosition="center"
    mt="sp_4"
    mr="sp_8"
    border={3}
    borderRadius="small"
    boxSizing="border-box"
    cursor="pointer"
    {...props}
  />
);

export default AttachedPicture;
